import React from "react";
import styled from "styled-components";
interface FormProps {
  children: React.ReactNode;
}
const Form = ({ children }: FormProps) => {
  return <FormContainer>{children}</FormContainer>;
};

export default Form;

const FormContainer = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 0.25em;
  row-gap: 1em;
`;
export const InputSection = styled.div`
  grid-column: 1 / span 2;
  margin-bottom: 20px;
`;
export const TableSection = styled.div`
  grid-column: 1 / span 2;
`;
